var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gig-review" },
    [
      _vm.formState == "sent"
        ? _c("post-success-call-to-action", {
            attrs: {
              heading: "Kiitos arvostelustasi!",
              message:
                "Arvostelusi on nyt lähetetty artistille ja lisätty artistin profiiliin.",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.formState != "sent"
        ? _c(
            "form",
            {
              staticClass: "default",
              attrs: {
                method: "post",
                name: "send-review",
                "accept-charset": "UTF-8",
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.sendReview.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.subject))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.points.$error },
                    },
                    [
                      _c("label", { staticClass: "mb-3" }, [
                        _vm._v("Miten keikka mielestäsi meni?"),
                      ]),
                      _vm._v(" "),
                      _c("radio-group", {
                        attrs: { items: _vm.pointsOptions, name: "points" },
                        model: {
                          value: _vm.points,
                          callback: function ($$v) {
                            _vm.points = $$v
                          },
                          expression: "points",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.message.$error },
                    },
                    [
                      _c("label", [_vm._v("Vapaa palaute keikasta")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.message.$model,
                            expression: "$v.message.$model",
                          },
                        ],
                        attrs: { rows: "4", id: "message" },
                        domProps: { value: _vm.$v.message.$model },
                        on: {
                          focusin: _vm.removeMessagePlaceholder,
                          focusout: _vm.addMessagePlaceholder,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.message,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 text-center mt-4" }, [
        _c(
          "button",
          { staticClass: "btn btn--call-to-action", attrs: { type: "submit" } },
          [_vm._v("\n                    Lähetä arvostelu\n                ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }